import { useContext, useMemo } from "react";
import styles from "./AdditionalProducts.module.css";
import OrderContext from "~/contexts/OrderContext";
import MenuContext from "~/contexts/MenuContext";
import { MenuTabItem } from "~/entities/menuEntities";
import { generateLine } from "~/helpers/cartHelpers";
import TaxContext from "~/contexts/TaxContext";
import { uploadcareConfig } from "~/configs/uploadcareConfig";

const AdditionalProducts = () => {
  const {
    orderSummary: { lines: orderLines },
    addOrderLine,
    readonlyCart,
  } = useContext(OrderContext);
  const { menu } = useContext(MenuContext);
  const { formatAmount } = useContext(TaxContext);

  const addToCart = (productData: MenuTabItem) => {
    if (!menu) {
      return;
    }
    addOrderLine(generateLine(productData, menu.code));
  };

  const additionalProducts = useMemo(() => {
    return (
      menu?.tabs.flatMap((tab) =>
        tab.items.filter(
          (item) =>
            !item.productData.children.length &&
            orderLines.every(
              (orderItem) => item.productCode !== orderItem.item.product.code
            )
        )
      ) ?? []
    );
  }, [orderLines, menu]);

  return additionalProducts.length > 0 ? (
    <div className={styles.wrapper}>
      <div className={styles.title}>Don&apos;t forget to add</div>
      <div className={styles.products}>
        {additionalProducts.map((product) => (
          <div
            key={product.code}
            className={styles.product}
            onClick={() => {
              if (!readonlyCart) {
                addToCart(product);
              }
            }}
          >
            <div className={styles.productInfo}>
              <div className={styles.productName}>{product.name}</div>
              <div className={styles.productPrice}>
                {formatAmount(product.productData.price)}
              </div>
            </div>
            {product.productData.image && (
              <img
                className={styles.productImage}
                src={uploadcareConfig.getUrl(
                  product.productData.image.fileId,
                  product.productData.image.modifiers
                )}
                alt={product.productData.image.fileName}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default AdditionalProducts;
